export default __webpack_public_path__ + "static/media/dog3.6a17c4f8.JPG";